import React from 'react';
import {
    IFooterSocialMediaIcon,
    IFooterPaymentMethods,
    IFooterBestPrice,
    IFooterSaferShopping,
} from '../../../interfaces/IFooter';
import { __ } from '../../../helpers/TranslationService';

export class FooterPayment extends React.Component<{ list: IFooterPaymentMethods[] }, {}> {
    render() {
        return (
            <div className="footer_icons_items">
                {this.props.list.map((item, key) => (
                    <div key={key} className="pull-left">
                        <img
                            width="52"
                            height="35"
                            src={item.image}
                            alt={item.altText}
                            title={item.title}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

export class FooterBestPrice extends React.Component<{ list: IFooterBestPrice[] }, {}> {
    render() {
        return (
            <div className="footer_icons_items">
                {this.props.list.map((item, key) => (
                    <div key={key} className="pull-left">
                        <img
                            width="75"
                            height="67"
                            src={item.image}
                            alt={item.altText}
                            title={item.title}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

export class FooterSaferShopping extends React.Component<{ list: IFooterSaferShopping[] }, {}> {
    render() {
        return (
            <div className="footer_icons_items">
                {this.props.list.map((item, key) => (
                    <div key={key} className="pull-left">
                        <img
                            width="75"
                            height="67"
                            src={item.image}
                            alt={item.altText}
                            title={item.title}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

export class FooterSocialMediaIcons extends React.Component<
    { list: IFooterSocialMediaIcon[] },
    {}
> {
    render() {
        return (
            <div className="footer_icons_items">
                {this.props.list.map((socialMedia, key) => (
                    <div key={key} className="pull-left">
                        <a
                            className={`icon-${socialMedia.social_icon}`}
                            href={socialMedia.targetUrl}
                            title={socialMedia.linkTitle}
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                    </div>
                ))}
            </div>
        );
    }
}

export class FooterIcons extends React.Component<
    {
        portalId: string;
        socialMediaIcons: IFooterSocialMediaIcon[];
        paymentMethods: IFooterPaymentMethods[];
        awards: IFooterBestPrice[];
        security: IFooterSaferShopping[];
    },
    {}
> {
    render() {
        return (
            <div className="footer_icons">
                {this.props.socialMediaIcons.length > 0 ? (
                    <div className="col-xs-12 col-is-6 col-sm-4 col-md-3 footer_icons_social">
                        <strong className="text-uppercase">
                            {__('Social Media', 'dreamlines')}
                        </strong>
                        <div className="footer_icons_items">
                            <FooterSocialMediaIcons list={this.props.socialMediaIcons} />
                        </div>
                    </div>
                ) : null}

                <div className="col-xs-12 col-is-6 col-sm-4 col-md-3 footer_images">
                    <strong className="text-uppercase">
                        {__('Payment methods', 'dreamlines')}
                    </strong>
                    <div className="footer_icons_items">
                        {this.props.paymentMethods ? (
                            <FooterPayment list={this.props.paymentMethods} />
                        ) : null}
                    </div>
                </div>

                <div className="col-xs-12 col-is-6 col-sm-4 col-md-3 footer_images">
                    <strong className="text-uppercase">
                        {__('Best price Guarantee', 'dreamlines')}
                    </strong>
                    <div className="footer_icons_items">
                        {this.props.awards ? <FooterBestPrice list={this.props.awards} /> : null}
                    </div>
                </div>

                <div className="col-xs-12 col-is-6 col-sm-4 col-md-3 footer_images">
                    <strong className="text-uppercase">{__('Safe shopping', 'dreamlines')}</strong>
                    <div className="footer_icons_items">
                        {this.props.awards ? (
                            <FooterSaferShopping list={this.props.security} />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}
